<template>
    <Transition name="information-modal">
        <div
            v-if="show"
            class="modal-mask"
        >
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div
                        class="modal-header"
                    >
                        <slot name="header">
                            default header
                        </slot>
                        <al-icon
                            icon="cross-inverted"
                            variant="secondary"
                            data-testid="close-information-modal"
                            @click="$emit('close')"
                        />
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            default body
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script setup lang="ts">
import {
    defineProps, useSlots, defineEmits
} from 'vue';
defineProps({ show: Boolean });
defineEmits<{(event: 'close'): void }>();

useSlots();

</script>
<style lang="scss">
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--modal-mask);
    display: table;
    transition: var(--modal-transition);

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        max-width: 558px;
        padding: 20px 24px 20px 24px;
        background-color: var(--color-white);
        border-radius: var(--border-radius-standard);
        box-shadow: 0 2px 8px var(--box-shadow-dark);
        transition: var(--modal-transition);
    }

    .modal-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        span {
            align-items: flex-start;

            &.al2-icon {
                cursor: pointer;
            }
        }
    }
}

.information-modal-enter-from,
.information-modal-leave-to  {
    opacity: 0;
}
</style>